import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFirstPartActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 18,
			stroke: "#BCA4FF",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 14,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5724 23.07C18.5724 23.0133 18.5724 22.9467 18.5724 22.87C18.5724 22.7933 18.5724 22.7133 18.5724 22.63C18.5724 22.5467 18.5724 22.465 18.5724 22.385C18.5757 22.305 18.579 22.2317 18.5824 22.165V22.17C18.5857 22.01 18.5874 21.845 18.5874 21.675C18.5907 21.5017 18.5924 21.32 18.5924 21.13C18.5924 20.7633 18.5874 20.3833 18.5774 19.99C18.5707 19.5967 18.5474 19.1883 18.5074 18.765C18.4674 18.3383 18.4057 17.8983 18.3224 17.445C18.239 16.9883 18.1207 16.515 17.9674 16.025L19.1324 15.645C19.3024 16.1883 19.434 16.71 19.5274 17.21C19.624 17.7067 19.694 18.1833 19.7374 18.64C19.784 19.0933 19.8124 19.5283 19.8224 19.945C19.8324 20.3617 19.8374 20.7617 19.8374 21.145C19.8374 21.335 19.8357 21.5183 19.8324 21.695C19.8324 21.8683 19.8307 22.035 19.8274 22.195C19.824 22.2617 19.8207 22.335 19.8174 22.415C19.8174 22.4917 19.8174 22.57 19.8174 22.65C19.8174 22.73 19.8174 22.8067 19.8174 22.88C19.8174 22.9533 19.8174 23.0167 19.8174 23.07H18.5724Z",
			fill: "white"
		})
	]
});
export default SvgFirstPartActive;
